<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import AppTabbar from "@/components/AppTabbar.vue";
import AppTopNav from "@/components/AppTopNav.vue";
import SiteFooter from "@/components/SiteFooter.vue";
import VideoPlayerDialog from "@/components/VideoPlayerDialog.vue";
import { useDevice } from "@/composables/useDevice";

const { t } = useI18n({ useScope: "global" });
const route = useRoute();
const { isDesktop, isMobile, isWideScreen, switchToDesktop } = useDevice();

// 进入游戏 / 登录页时不显示 Tabbar / TopNav
const showChrome = computed(() => {
  const m = route.meta as { fullscreen?: boolean };
  return !m.fullscreen;
});

// 大屏却被手动锁成手机版 → 显示一个明显的"切回电脑版"悬浮按钮
const showBackToDesktop = computed(
  () => showChrome.value && isMobile.value && isWideScreen.value,
);
</script>

<template>
  <div class="h-full flex flex-col bg-bg text-white">
    <!-- 布局由 useDevice 驱动（含手动切换），不再纯靠 CSS 断点 -->
    <AppTopNav v-if="showChrome && isDesktop" class="flex-none" />
    <main class="flex-1 min-h-0 overflow-auto">
      <router-view v-slot="{ Component }">
        <keep-alive :include="['Home', 'Library', 'Mine']">
          <component :is="Component" />
        </keep-alive>
      </router-view>
      <SiteFooter v-if="showChrome" />
    </main>
    <AppTabbar v-if="showChrome && !isDesktop" class="flex-none" />

    <!-- 大屏锁成手机版时的"切回电脑版"悬浮入口（手机真机不会出现） -->
    <button
      v-if="showBackToDesktop"
      class="fixed top-3 left-1/2 -translate-x-1/2 z-[60] px-4 py-2 rounded-full bg-brand text-bg text-sm font-medium shadow-lg hover:brightness-110 active:scale-95 transition"
      @click="switchToDesktop"
    >
      💻 {{ t("app.backToDesktop") }}
    </button>

    <!-- 全局视频播放器（实况视频点击播放） -->
    <VideoPlayerDialog />
  </div>
</template>
